export default function getBankAccountString(
    bankNumber: number,
    bankName?: string,
) {
    return bankName ?? `Id da Conta no ERP: ${bankNumber}`;
}
